"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AreaAgentListingsResponse$ = exports.AreaAgentListingsResponse$outboundSchema = exports.AreaAgentListingsResponse$inboundSchema = void 0;
exports.areaAgentListingsResponseToJSON = areaAgentListingsResponseToJSON;
exports.areaAgentListingsResponseFromJSON = areaAgentListingsResponseFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const agentlistingswrapper_js_1 = require("./agentlistingswrapper.js");
/** @internal */
exports.AreaAgentListingsResponse$inboundSchema = z.object({
    data: z.array(agentlistingswrapper_js_1.AgentListingsWrapper$inboundSchema),
});
/** @internal */
exports.AreaAgentListingsResponse$outboundSchema = z.object({
    data: z.array(agentlistingswrapper_js_1.AgentListingsWrapper$outboundSchema),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var AreaAgentListingsResponse$;
(function (AreaAgentListingsResponse$) {
    /** @deprecated use `AreaAgentListingsResponse$inboundSchema` instead. */
    AreaAgentListingsResponse$.inboundSchema = exports.AreaAgentListingsResponse$inboundSchema;
    /** @deprecated use `AreaAgentListingsResponse$outboundSchema` instead. */
    AreaAgentListingsResponse$.outboundSchema = exports.AreaAgentListingsResponse$outboundSchema;
})(AreaAgentListingsResponse$ || (exports.AreaAgentListingsResponse$ = AreaAgentListingsResponse$ = {}));
function areaAgentListingsResponseToJSON(areaAgentListingsResponse) {
    return JSON.stringify(exports.AreaAgentListingsResponse$outboundSchema.parse(areaAgentListingsResponse));
}
function areaAgentListingsResponseFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.AreaAgentListingsResponse$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'AreaAgentListingsResponse' from JSON`);
}
//# sourceMappingURL=areaagentlistingsresponse.js.map